/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, actions: NonNullable<unknown>, name: NonNullable<unknown> }} Seo_Api_A_Endpoints_OtherInputs */

const en_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoints: ${i?.actions}. Every one takes the same authentication and returns the same normalized response shape, so reaching a second ${i?.name} endpoint is a change of URL and nothing else.`)
};

const zh_hans1_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个接口：${i?.actions}。每个接口使用相同的认证方式，返回相同的统一响应结构，所以调用另一个 ${i?.name} 接口只需换一个 URL，别的都不用改。`)
};

const pt_br2_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoints: ${i?.actions}. Todos usam a mesma autenticação e retornam o mesmo formato de resposta normalizado, então usar um segundo endpoint para ${i?.name} é só trocar a URL, e nada mais.`)
};

const es_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoints: ${i?.actions}. Todos usan la misma autenticación y devuelven la misma estructura de respuesta normalizada, así que llegar a un segundo endpoint de ${i?.name} es solo cambiar la URL.`)
};

const fr_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoints : ${i?.actions}. Chacun utilise la même authentification et renvoie la même forme de réponse normalisée, donc passer à un second endpoint ${i?.name} revient à changer l’URL et rien d’autre.`)
};

const de_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Endpoints: ${i?.actions}. Jeder nutzt dieselbe Authentifizierung und liefert dieselbe normalisierte Antwortstruktur, sodass der Wechsel zu einem zweiten ${i?.name}-Endpoint nur eine geänderte URL bedeutet.`)
};

const ru_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Эндпоинтов: ${i?.count} (${i?.actions}). У всех одна аутентификация и один нормализованный формат ответа, поэтому переход ко второму эндпоинту ${i?.name} это смена URL и ничего больше.`)
};

const it_seo_api_a_endpoints_other = /** @type {(inputs: Seo_Api_A_Endpoints_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} endpoint: ${i?.actions}. Ognuno usa la stessa autenticazione e restituisce la stessa forma di risposta normalizzata, quindi passare a un secondo endpoint di ${i?.name} significa cambiare l'URL e nient'altro.`)
};

/**
* | output |
* | --- |
* | "{count} endpoints: {actions}. Every one takes the same authentication and returns the same normalized response shape, so reaching a second {name} endpoint is..." |
*
* @param {Seo_Api_A_Endpoints_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_api_a_endpoints_other = /** @type {((inputs: Seo_Api_A_Endpoints_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Api_A_Endpoints_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_api_a_endpoints_other(inputs)
	if (locale === "pt-BR") return pt_br2_seo_api_a_endpoints_other(inputs)
	if (locale === "es") return es_seo_api_a_endpoints_other(inputs)
	if (locale === "fr") return fr_seo_api_a_endpoints_other(inputs)
	if (locale === "de") return de_seo_api_a_endpoints_other(inputs)
	if (locale === "ru") return ru_seo_api_a_endpoints_other(inputs)
	if (locale === "it") return it_seo_api_a_endpoints_other(inputs)
	return en_seo_api_a_endpoints_other(inputs)
});